import type { AnalyticsState, MutationClass, PeriodsData } from '../../../models'

import Vue from 'vue'

export class SetDistDataMutation implements MutationClass {
  static execute(
    this: void,
    state: AnalyticsState,
    payload: { data: Partial<PeriodsData>; selectedId?: string },
  ): void {
    if (!payload.selectedId) {
      state.data.overall.dist = Object.assign({}, state.data.overall.dist, payload.data)
    } else {
      const selectedIdData = state.data.ids[payload.selectedId]
      if (!selectedIdData) {
        Vue.set(state.data.ids, payload.selectedId, {
          dist: payload.data,
          pivots: {},
          related: {},
        })
      } else {
        selectedIdData.dist = Object.assign({}, selectedIdData.dist, payload.data)
      }
    }
  }
}
